<div class="edit-account__wrapper flex flex-col">
    <div class="inline-flex gap-[0.62rem]">
      <a (click)="goBack()" class="mb-2 translate-y-[2px] cursor-pointer"
        ><img src="assets/images/svgs/chevron-left.svg" alt=""
      /></a>

      <h1
        class="translate-y-1 text-2xl font-normal leading-[1.3125rem] text-mango-black17"
      >
        {{ jointAccountName$ | async }}
      </h1>
    </div>

    <div class="tab__wrapper mb-6 mt-[0.94rem]">
      <!-- Tabs for desktop -->

      <div class="hidden w-fit rounded-lg bg-white sm:block">
        <nav class="flex w-fit space-x-4 p-[0.31rem]" aria-label="Tabs">
          <a
            [routerLink]="userDetailsUrl"
            [queryParams]="updateId ? { updateId: updateId } : null"
            routerLinkActive="bg-mango-lightOrange text-mango"
            class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
            ><span>User Details</span></a
          >
            <a
            *ngIf="updateId"
            [routerLink]="updateApprovalUrl"
            [queryParams]="updateId ? { updateId: updateId } : null"
            routerLinkActive="bg-mango-lightOrange text-mango"
            class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
            ><span>Pending Approval</span></a
          >

           <a
            *ngIf="updateId"
            [routerLink]="updateHistoryUrl"
            [queryParams]="updateId ? { updateId: updateId } : null"
            routerLinkActive="bg-mango-lightOrange text-mango"
            class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
            ><span>Update History</span></a
          >
          <!-- <a
            [routerLink]="accountsUrl"
            routerLinkActive="bg-mango-lightOrange text-mango"
            class="rounded-lg px-[0.94rem] py-[0.31rem] text-sm font-normal text-gray-500 hover:bg-gray-50"
            ><span>Accounts</span></a
          > -->
        </nav>
      </div>
    </div>
    <router-outlet></router-outlet>
